const mailId1 = "ATCI.L-TT.Automation";
const mailId2 = "GenAIAutomationLearn";
const domain = "accenture.com"
export const ExplorebyProgramData = [
  {
    id: "1",
    icon: "images/AIAcademy/Icon1.png",
    title: "Why enroll?",
    para: [
      "Master Agentic AI fundamentals and gain hands-on skills with the latest ecosystem tools across top platforms.",
      "Builds and deploy autonomous AI agents that think and act independently, speeding up solution delivery.",
      "Stay future-ready and elevate your role in AI-driven transformations."
    ],
  },
  {
    id: "2",
    icon: "images/AIAcademy/Icon2.png",
    title: "Need Support?",
    para: [
      <>
        Dedicated office hours:<br/>Tuesdays 2 PM - 3 PM IST{" "}
        <a href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_NWQzZjE0ZjUtYjMwMy00NjA5LTk2ODEtMGQyMjNmOGI1NmYx%40thread.v2/0?context=%7b%22Tid%22%3a%22e0793d39-0939-496d-b129-198edd916feb%22%2c%22Oid%22%3a%2203217ba1-4e53-4630-bef1-f049f0353a69%22%7d" target="_blank">
          Link
        </a><br/>
        Thursdays 7 PM - 8 PM IST {" "}
        <a href="https://teams.microsoft.com/l/meetup-join/19%3ameeting_ZTRlYmM4MDUtMmEyNC00ZDJhLTg5NWUtNjIzNzI5ZDVlYmEy%40thread.v2/0?context=%7b%22Tid%22%3a%22e0793d39-0939-496d-b129-198edd916feb%22%2c%22Oid%22%3a%2203217ba1-4e53-4630-bef1-f049f0353a69%22%7d" target="_blank">
          Link
        </a>
      </>,
      <>
        Access the{" "}
        <a href="https://kxdocuments.accenture.com/contribution/3a131040-43af-415c-8a31-f38fb6ca70ce" target="_blank">FAQs here</a>
      </>,
      <>
        Support Email IDs:<br/>
         <a href="mailto:ATCI.L-TT.Automation" target="_blank">{mailId1}@{domain}</a>{" "}(for ATCI practitioners)<br/>
         <a href="mailto:GenAIAutomationLearn" target="_blank">{mailId2}@{domain}</a>{" "}(for Non-ATCI practitioners)
      </>,
    ],
  },
];
